<svg>
    <!-- This label shows when there is data -->
    <g *ngIf="label.status == 'active'" [attr.id]="label.displayIndex" transform="translate(0,-75)">

        <g class="leaf-decoration" [class.leaf-decoration--hidden]="shouldHideLeaves(label)">
            <!-- Silent renewal -->
            <g *ngIf="i%2 == 0" transform="translate(-45,50) scale(0.45 0.45)" class="custom-cursor-context-menu no-pointer-events leaf">  
                    <image height="115" width="115" href="assets/tree-editor/level_6/leave_6_bottom_color.svg" />
            </g> 

            <g *ngIf="i%2 == 1" transform="translate(-45,70) scale(0.45 0.45)" class="custom-cursor-context-menu no-pointer-events leaf">  
                    <image height="115" width="115" href="assets/tree-editor/level_6/leave_6_top_color.svg" />
            </g> 
        </g>
        <g [attr.id]="label.displayIndex + '-node'" 
        [ngClass]="{'zoom-in-node': isZoomedNode,'highlighted-node': (selectedNodeId === label.displayIndex) && (animationPhase === 'highlight' || this.animationPhase === 'travelToRoot')
        }">
            <image transform="scale(1,0.8)" x="0" y="86" height="36" width="210" [attr.href]="'assets/tree-editor/level_6/lbl_level_6_' + (genderMap[label.gender] || 'unknown') + '_bordered.svg'" />
            <text *ngIf="label.gender == 'M'" transform="translate(20,88)"
            class='element-over-hand text-male male-color' (click)="changeRootPerson.emit(label)">
            {{splitDisplayName[0]?.name}}</text>
            <text *ngIf="label.gender == 'F'" transform="translate(20,88)"
            class='element-over-hand text-female female-color' (click)="changeRootPerson.emit(label)">
            {{splitDisplayName[0]?.name}}</text>
            <text *ngIf="label.gender == 'U'" transform="translate(20,88)"
            class='element-over-hand text-unknown unknown-color' (click)="changeRootPerson.emit(label)">
            {{splitDisplayName[0]?.name}}</text>
        </g>
        <!-- If there are more data in the branch continuous button shows -->
        <g class="leaf-decoration" [class.leaf-decoration--hidden]="shouldHideLeaves(label)" *ngIf="label.motherId > -1 || label.fatherId > -1" class="leaf">
            <image x="220" y="75" height="18" width="18" href="assets/tree-editor/level_6/btn_continue.svg" />          
        </g>
    </g>

    <!-- This label shows when there is no data(Grey out label) -->     
    <g *ngIf="label.status === 'disable'" [attr.id]="label.displayIndex" transform="translate(0,-75)" class="element-over-hand" (click)="addParent(i, label)">
         <!-- Disabled Leaves -->
         <g *ngIf="i%2 == 0" transform="translate(-45,50) scale(0.45 0.45)" class="custom-cursor-context-menu no-pointer-events">  
            <image height="115" width="115" href="assets/tree-editor/level_6/leave_6_bottom_grey.svg" />
        </g> 

        <g *ngIf="i%2 == 1" transform="translate(-45,70) scale(0.45 0.45)" class="custom-cursor-context-menu no-pointer-events">  
            <image height="115" width="115" href="assets/tree-editor/level_6/leave_6_top_grey.svg" />
        </g> 
        <image transform="scale(1,0.8)" x="0" y="86" height="36" width="210" href="assets/tree-editor/level_6/lbl_level_6_disable.svg" class="custom-cursor-context-menu no-pointer-events"/>
        <g>
        <text transform="translate(20,88)" fill="#c1c2bd" font-family="Arial" font-size="14">+</text>                                    
        <text *ngIf="i%2 == 0" class="text-disable empty-slot" transform="translate(40,88)">{{"lbl_add_mother" | translate}}</text>
        <text *ngIf="i%2 !== 0" class="text-disable empty-slot" transform="translate(40,88)">{{"lbl_add_father" | translate}}</text>
        </g>
    </g>  
</svg>>
